import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './assets/locales/translations';

i18n.use(initReactI18next).init({
    // debug: true,
    resources: translations,
    lng: 'en',
    fallbackLng: 'en',
    returnNull: false,
    returnEmptyString: false,
});

export default i18n;
